export const apiUrl = import.meta.env.VITE_API_URL;

export const Role = {
  'Admin': 'Admin',
  'Capturer': 'Capturer',
  'Reviewer': 'Reviewer',
  'Viewer': 'Viewer',
};

/**
 * Plans and revisions
 */
export const ItemType = {
  Node: 'node',
  Edge: 'edge',
};
export const NodeType = {
  Project: 'project',
  Link: 'link',
};

export const PageType = {
  CoverPage: 'Cover Page',
  VisionPage: 'Vision Page',
  NodePage: 'Node Page',
};

export const MindmapActionMode = {
  SelectFramework: 'select-framework',
  AddProject: 'add-project',
  AddLink: 'add-link',
};

export const PlanStatus = {
  Published: 'Published',
  Draft: 'Draft',
};

export const Node = {
  project: {
    default: {
      backgroundColor: '#828F9D',
    },
  },
};

export const projectLevels = [
  {
    level: 'Level 1',
    fullName: 'Level 1: Game Changers',
    name: 'Game Changers',
    projectType: 'Government Mega Projects',
    description: 'Government funded mega infrastructure projects. By nature, these are projects of multi-sectoral significance. They serve as a foundation for the implementation of Major (Social and/or Economic) Enabler Projects (see Level 2 Projects). Level 1 Catalytic Projects may cover more than just one district or province. They are significantly catalytic, unlocking potential across several sectors.',
    color: '#2A2C91',
  },
  {
    level: 'Level 2',
    fullName: 'Level 2: Major Enablers',
    name: 'Major Enablers',
    projectType: 'Private Sector and Public Private Partnerships',
    description: 'Private sector led partnership projects, such as PPPs and joint ventures, that have the capacity to be major enablers in a particular sector or sectors. Level 2 Catalytic Projects leverage a combination of private and public sector investment, or purely private sector investment.',
    color: '#EB73A6',
  },
  {
    level: 'Level 3',
    fullName: 'Level 3: Major Needs Projects',
    name: 'Major Needs Projects',
    projectType: 'Community Projects',
    description: 'Community or civil society-led initiatives that improve the quality of life of a particular community within a district. These projects address pressing needs - such as basic services, social cohesion, gender-based violence, reproductive rights, HIV/AIDS, or food security - and reflect partnerships between government and communities. While Level 3 Catalytic Projects are often smaller in financial scale, they have meaningful socio-economic impact and are typically funded through grants or corporate social investment. They promote participation and co-governance, with benefits visible in the short, medium, and long term. Projects may be single-sector or multi-sectoral.',
    color: '#009844',
  },
];
